export const expectedPhoneLength = 10;

export const isPhoneValid = (value: string, required: boolean): boolean => {
  return (
    (!required && value.length === 0) || value.length === expectedPhoneLength
  );
};
